import { render, staticRenderFns } from "./TenLast.vue?vue&type=template&id=f26074a4&"
import script from "./TenLast.vue?vue&type=script&lang=js&"
export * from "./TenLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports